/* * Copyright © 2023, Lumenore Inc. All rights reserved. *
* This software is the confidential and proprietary information of *
* Lumenore Inc. "Confidential Information".
* You shall not disclose such Confidential Information and shall use it only in *
* accordance with the terms of the intellectual property agreement *
* you entered into with Lumenore Inc. *
* THIS SOFTWARE IS INTENDED STRICTLY FOR USE BY Lumenore Inc. *
* AND ITS PARENT AND/OR SUBSIDIARY COMPANIES. Lumenore *
* MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE, *
* EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF *
* MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. *
* Lumenore SHALL NOT BE LIABLE FOR ANY DAMAGES SUFFERED BY ANY PARTY AS A RESULT *
* OF USING, MODIFYING OR DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES. *
* */

import baseUrl, { isProductionEnvironment } from "./baseUrlConfig";

// host names
const identityAPIHostName = process.env.IDENTITY_API_HOSTNAME || 'identity-server-service-rsh';
const commonsAPIHostName = process.env.COMMONS_API_HOSTNAME || 'commons-server-service-rsh';

// base urls
export const identityApiBaseUrl = `${baseUrl}/secure`;
export const groupApiBaseUrl = `${baseUrl}/group`;
export const adminApiBaseUrl = `${baseUrl}/admin`;
export const commonsApiBaseUrl = `${baseUrl}/core`;
export const onboardApiBaseUrl = `${baseUrl}/onboard`;
export const samlApiBaseUrl = `${baseUrl}/saml`;
export const gatewayApiBaseUrl = process.env.NODE_ENV === "development" ? process.env.GATEWAY_API_HOSTNAME : (`http://${process.env.GATEWAY_API_HOSTNAME}:8080`);
//backend base urls
const identityBackendApiBaseUrl = isProductionEnvironment ? `http://${identityAPIHostName}:8080` : identityApiBaseUrl

const commonsApiBackendBaseUrl = isProductionEnvironment ? `http://${commonsAPIHostName}:8080` : commonsApiBaseUrl


//---------------------------------------------

// token details
export const GET_BACKEND_USERDATA_TOKEN = `${identityBackendApiBaseUrl}/identity/userData-token?token=`
export const GET_NO_AUTH_TOKEN = `${gatewayApiBaseUrl}/api/v2/login`
//organization details
export const GET_WHITE_LABELLING_CONTENT = `${commonsApiBaseUrl}/get-manifest-data`
// Server-side whitelabelling lookup follows the existing internal commons routing.
export const GET_WHITE_LABELLING_CONTENT_BACKEND = `${commonsApiBackendBaseUrl}/get-manifest-data`
export const GET_ORGANIZATION_CONFIG = `${commonsApiBaseUrl}/get-org-config`
export const GET_ORGANIZATION_DATA = `${adminApiBaseUrl}/get-org-data`
export const GET_ORGANIZATION = `${commonsApiBaseUrl}/get-organization`
export const GET_ORGANIZATION_FROM_TOKEN = `${identityApiBaseUrl}/identity/get-organization-from-token`

//Forgot password
export const GENERATE_OTP_WITH_ORGANIZATION = `${commonsApiBaseUrl}/generate-otp`
export const VERIFY_OTP = `${commonsApiBaseUrl}/verify-otp`
export const CHANGE_PASSWORD_USING_OTP = `${commonsApiBaseUrl}/change-password-using-otp`
export const GENERATE_OTP_WITHOUT_ORGANIZATION = `${commonsApiBaseUrl}/web/unlock-user`
export const UNLOCK_USER_WITH_ORG = `${commonsApiBaseUrl}/unlock-user`
export const CHANGE_PASSWORD = `${commonsApiBaseUrl}/web/change-password`
export const GET_PASSWORD_POLICY = `${commonsApiBaseUrl}/get-password-policy`

//Login endpoints
export const START_LOGIN = `${commonsApiBaseUrl}/login/start`
export const VALIDATE_PASSWORD = `${commonsApiBaseUrl}/validate-password`
export const VALIDATE_PASSWORD_WEB = `${commonsApiBaseUrl}/validate-password-web`
export const GENERATE_TOKEN = `${commonsApiBaseUrl}/generate-token`
export const VALIDATE_TWO_FACTOR_AUTHENTICATION = `${commonsApiBaseUrl}/validate`
export const GET_CAPTCHA = `${commonsApiBaseUrl}/get-captcha`
export const VERIFY_CAPTCHA = `${commonsApiBaseUrl}/verify-captcha`

//SSO Endpoints

export const SSO_WITH_MICROSOFT_OR_OKTA = `${samlApiBaseUrl}/services/auth/SAMLAuthRequestLumenore`
export const GET_SSO_CLIENTS = `${commonsApiBaseUrl}/jwt/get-sso-clients`
export const AUTHENTICATE_SSO = `${commonsApiBaseUrl}/sso/jwt/sso-authenticate`
// Server-only (internal host): used by getSSOUserOrganizations in getServerSideProps
export const VALIDATE_USER_BACKEND = `${commonsApiBackendBaseUrl}/validate-user`
// Client-reachable (relative): used by validateSSOUserOrganization on org selection
export const VALIDATE_USER = `${commonsApiBaseUrl}/validate-user`
export const SSO_REQUEST = `${samlApiBaseUrl}/services/auth/SSORequest`

//Signup endpoints
export const START_SIGNUP = `${onboardApiBaseUrl}/start`
export const VERIFY_SIGNUP_EMAIL = `${onboardApiBaseUrl}/setSignUpPassword`
export const VERIFY_EMAIL_SEND_OTP = `${commonsApiBaseUrl}/send-otp`
export const VERIFY_EMAIL_VERIFY_SEND_OTP = `${commonsApiBaseUrl}/verify-send-otp`
export const GET_SIGNUP_INDUSTRIES = `${onboardApiBaseUrl}/get-industry`
export const SIGNUP_USER = `${onboardApiBaseUrl}/signup-user`

//Network endpoints
export const PING_URL = `${commonsApiBaseUrl}/ping`

//user endpoints
export const GET_USERS_AND_GROUPS = `${groupApiBaseUrl}/get-allusersandgroupsReact`;
export const GET_USERVO = `${identityApiBaseUrl}/identity/user-vo`;
export const GET_OAUTH2 = `${identityApiBaseUrl}/oauth2`;
// Server-side only: OAuth2 token endpoint hit by the /api/oauth/token proxy.
// In production this targets the internal identity host (mirroring GET_BACKEND_USERDATA_TOKEN);
// in dev it resolves to `${GET_OAUTH2}/token` via the gateway (`/secure/...`).
export const OAUTH2_TOKEN_BACKEND = `${identityApiBaseUrl}/oauth2/token`;
//Embed endpoints
export const FETCH_EMBED_DETAILS = `${identityApiBaseUrl}/embed/fetch`;
